import React from 'react';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';
import { summaryTextService } from '../../../services/summaryTextService';

/**
 * @typedef {object} SummarySectionSummaryDataMostCommonLocations
 * @property {string} [locationId]
 * @property {number} [percentage]
 */

/**
 * @typedef {object} SummarySectionSummaryDataHighestOhts
 * @property {string} [name]
 * @property {number} [value]
 */

/**
 * @typedef {object} SummarySectionSummaryDataHighestDeviceClasses
 * @property {string} [name]
 * @property {number} [value]
 */

/**
 * @typedef {object} SummarySectionSummaryDataStrengths
 * @property {number} percentage
 * @property {string} label
 */

/**
 * @typedef {object} SummarySectionSummaryDataChallenges
 * @property {number} percentage
 * @property {string} label
 */

/**
 * @typedef {object} SummarySectionSummaryData
 * @property {SummarySectionSummaryDataMostCommonLocations[]} [mostCommonLocations]
 * @property {SummarySectionSummaryDataHighestOhts[]} [highestOhts]
 * @property {SummarySectionSummaryDataHighestDeviceClasses[]} [highestDeviceClasses]
 * @property {number} [yearsInVip]
 * @property {SummarySectionSummaryDataStrengths[]} [strengths]
 * @property {SummarySectionSummaryDataChallenges[]} [challenges]
 */

/**
 * @typedef {object} SummarySectionProps
 * @property {SummarySectionSummaryData} [summaryData]
 * @property {boolean} [loading]
 * @property {number} [totalUnitCount]
 * @property {string} [companyName]
 */

const EMPTY_SUMMARY_DATA = {
  strengths: [],
  challenges: []
};

/**
 * @param {SummarySectionProps} props
 */
const SummarySection = props => {
  const { summaryData = EMPTY_SUMMARY_DATA, loading = false, totalUnitCount, companyName } = props;
  const summaryText = summaryTextService.getSummaryText(summaryData, companyName, totalUnitCount);

  return (
    <section className='summary-section'>
      <h4>Summary Section</h4>
      <div className='summary-section__content'>
        <SkeletonWrapper show={loading} inheritParentSize>
          <p>{summaryText}</p>

          <ul>
            {summaryData.strengths?.map((item, index) => (
              <li key={item.label}>
                Strength {index + 1}: {item.label} - {item.percentage}%
              </li>
            ))}

            {summaryData.challenges?.map((item, index) => (
              <li key={item.label}>
                Challenge {index + 1}: {item.label} - {item.percentage}%
              </li>
            ))}
          </ul>
        </SkeletonWrapper>
      </div>
    </section>
  );
};

export default SummarySection;
